
import { Step } from "@/lib/types";
import { introductionStep } from "./introduction";
import { signupStep } from "./signup";
import { createTiktokStep } from "./createTiktok";
import { warmupStep } from "./warmup";
import { warmupDaysStep } from "./warmupDays";
import { setupAccountStep } from "./setupAccount";
import { reposterDashboardStep } from "./reposterDashboard";
import { howToUseDashboardStep } from "./howToUseDashboard";
import { congratulationsStep } from "./congratulations";

// Export all steps in an array to maintain the sequence
export const onboardingSteps: Step[] = [
  introductionStep,
  signupStep,
  createTiktokStep,
  warmupStep,
  warmupDaysStep,
  setupAccountStep,
  reposterDashboardStep,
  howToUseDashboardStep,
  congratulationsStep
];

// Export individual steps for easier direct editing
export {
  introductionStep,
  signupStep,
  createTiktokStep,
  warmupStep,
  warmupDaysStep,
  setupAccountStep,
  reposterDashboardStep,
  howToUseDashboardStep,
  congratulationsStep
};
